import { Box, Typography } from '@offline-mui/material'
import { ReactNode } from 'react'
import leoLion from './assets/leo_lion_roar.gif'

// Leo logo, name and subline. Every Invoice page shows it in its header.
export function LeoBrand() {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
      <Box component="img" src={leoLion} alt="" sx={{ display: 'block', height: 84, width: 84, objectFit: 'contain' }} />
      <Box>
        <Typography variant="h1" component="h1">Leo</Typography>
        <Typography variant="body2" sx={{ color: '#ffe8c2', mt: 0.25 }}>Lighter. Faster. Smarter.</Typography>
      </Box>
    </Box>
  )
}

// Header for the Invoice pages. On its own it shows the brand; the invoice page passes its import box and search form.
export function LeoHeader({ children, sx }: { children?: ReactNode; sx?: object }) {
  return (
    <Box
      component="header"
      sx={{
        p: 2.5,
        borderRadius: 3,
        color: 'common.white',
        background: 'linear-gradient(115deg, #0b6e6a 0%, #1d4e89 58%, #5b4b8a 100%)',
        ...sx,
      }}
    >
      {children ?? <LeoBrand />}
    </Box>
  )
}
